// Module
var code = "<strong class=\"h5 me-2\"> <span class=\"price-component price-net\"> {{ $ctrl.getNet() }} {{ 'net' | t }} </span> </strong> <span class=\"price-component price-gross\"> ({{ $ctrl.getGross() }} brutto) </span> ";
// Exports
module.exports = code;